class SideMenu {
  el;
  buttonOpen;
  buttonClose;
  body;
  backdrop;
  menuLinks;


  constructor(sideMenu) {
    this.el = sideMenu;
    this.buttonOpen = document.querySelector(".js-button-side-menu");
    this.buttonClose = this.el.querySelector(".js-button-close");
    this.body = document.querySelector("body");
    this.backdrop = document.querySelector(".backdrop");
    // this.menuLinks = this.el.querySelectorAll(".menu-item.anchor a");


    this.bindListeners();
  }

  bindListeners() {
    this.buttonOpen.addEventListener("click", this.open.bind(this));
    this.buttonClose.addEventListener("click", this.close.bind(this));
    this.backdrop.addEventListener("click", this.close.bind(this));
  }

  open() {
    this.body.classList.add("no-scroll");
    this.backdrop.classList.add("active");
    this.el.classList.add("open");
    this.buttonOpen.setAttribute("aria-expanded", true);
    this.buttonClose.style.display = "flex";
  }

  close() {
    this.body.classList.remove("no-scroll");
    this.backdrop.classList.remove("active");
    this.el.classList.remove("open");
    this.buttonOpen.setAttribute("aria-expanded", false);
    this.buttonClose.style.display = "none";
  }
}

const sideMenu = document.querySelector(".js-side-menu");
if (sideMenu) {
  new SideMenu(sideMenu);
}
